export function error(functionName,key) {
    const css = 'color: white; background-color: red; padding: 2px 5px; border-radius: 2px';
    const reset = 'color: inherit; background-color: none; padding: 0; border-radius: 0;'
    console.log(`Error found in %c${functionName}%c with the argument %c${key}`, css, reset, css);
}